exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trial-balance-row {\n  background-color: white; }\n  .trial-balance-row:hover {\n    cursor: pointer; }\n  .trial-balance-row.selected {\n    background-color: #bce5cc;\n    border-color: #43ac6a !important; }\n", ""]);

// exports
